import { lazy } from "react";
import Loadable from "app/components/Loadable";
import { element } from "prop-types";
import { Label, LineAxis } from "@mui/icons-material";
import { Lazy } from "yup";


 const VendorRequest = Loadable(lazy(()=> import('./Vendor_requesest')))
 const VendorRequestList = Loadable(lazy(()=> import('./FormVender')))
 const AllVendorList = Loadable(lazy(()=>import('./all_vendor/Vendor/Vendor'))) 
 const AddVendor = Loadable(lazy(()=>import('./FormVender')))
  const AddPartnerForm = Loadable(lazy(()=>import('./vendorReq/NewPartner')))
 const Ven_UpdateProfile = Loadable(lazy(()=>import('./all_vendor/Ven_UpdateProfile')))
 const UpdatePage =Loadable(lazy(()=>import('./all_vendor/UpdatePage')))
 
 const PartnerDis = Loadable(lazy(()=>import('./all_vendor/Vendor/PartnerDis')))
 const EditGymPass = Loadable(lazy(()=>import('./PassCreate/EditPass')))
 const Coupon = Loadable(lazy(()=>import('./discount_Coupon/AddPass')))
 const CouponList = Loadable(lazy(()=>import('./discount_Coupon/Coupon')))
 const Contact_Vendor = Loadable(lazy(()=>import('./Contacts_Vendor')))
 const CouponSetting = Loadable(lazy(()=>import('./discount_Coupon/Setting')))
 const OfferCpCreare = Loadable(lazy(()=>import('./discount_Coupon/OfferCPCreate')))
 const PoolCPCreate = Loadable(lazy(()=>import('./discount_Coupon/PoolCp_Create')))

 

const VendorRoutes = [
  { path: "/vendor-request", element: <VendorRequest />},
  { path: "/Add-vendor", element: <VendorRequestList />},
  {path:'/vendor-list',element:<AllVendorList />},
  {path:'/add-vendor',element:<AddVendor />},
  {path:'/add-partner',element:<AddPartnerForm />},

  { path: "/ven-updateProfie", element: <Ven_UpdateProfile />},
  {path:'/updatePage/:id',element:<UpdatePage />},
 
  {path:'/editbyPass/:id',element:<EditGymPass />},
  {path:'/coupon',element:<Coupon />},
  {path:'/coupon-list',element:<CouponList />},
  {path:'/partner-consert',element:<Contact_Vendor />},
  {path:'/coupon-setting',element:<CouponSetting />},
  {path:'/create-coupon',element:<OfferCpCreare />},
  {path:'/create-pool-coupon',element:<PoolCPCreate />},
  // {path:'/partner-payment',element:<PartnerDis />}


  ];

export default VendorRoutes;
